import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider';
import ToggleSwitch from '../../Models/ToggleSwitch';

const AddFile = () => {
  const { SetNotification } = useStateContext();
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const [file_, setFile] = useState(null);
  const [Active, setActive] = useState(1);
  const [lang, setLang] = useState("English");
  const [sending, setIsSending] = useState(false);
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
 
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    const payload = {
      title: titleRef.current.value,
      description: descriptionRef.current.value,
      file: file_,
      conference_id: conferenceId,
      active: Active ? 1 : 0  ,
      lang: lang,
    };

    try {
      const response = await AxiosClient.post('/public-files', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.status === 201) {
        SetNotification('File added successfully', 'success');
        navigate(-1);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'An error occurred while adding the file.';
      SetNotification(errorMessage, 'danger');
    }
    setIsSending(false);
  };
  const {API} = useStateContext () ; 
  return (
    <div className="m-4">
      <h5>Language</h5>
      <button
        className={`btn btn-${lang === 'Arabic' ? 'info' : 'dark'} m-2`}
        onClick={() => setLang("Arabic")}
      >
        Arabic
      </button>
      <button
        className={`btn btn-${lang === "English" ? 'info' : 'dark'} m-2`}
        onClick={() => setLang("English")}
      >
        English
      </button>
      {lang === 'Arabic' ? <img src="https://flagsapi.com/IQ/shiny/64.png" /> : <img src="https://flagsapi.com/GB/shiny/64.png" />}

      <form className="form-group" >
        <h5>{lang === "English" ? 'Title' : "عنوان الملف"}</h5>

        <div className="input-group input-group-outline mb-3">
        <input type="text" className="form-control" placeholder="Enter title" ref={titleRef} />
     </div>
        <h5>{lang === "English" ? 'Description' : "وصف الملف"}</h5>
        <div className="input-group input-group-outline mb-3">

        <textarea className="form-control" placeholder="Enter description" rows={5} ref={descriptionRef} />
        </div> 
        <h5>{lang === "English" ? 'Upload File' : "حمل الملف"}</h5>
        <div className="input-group input-group-outline mb-3">

        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
          className="form-control"
        />
        </div>
        <hr className="border-gray-300 my-4" />

<div className="w-full flex flex-wrap items-center">
   is the File public
  <ToggleSwitch message=""  state={Active} updateIsActive={setActive}/>
</div>
        {sending ? (
          <h1>Sending...</h1>
        ) : (
          <button onClick={handleSubmit} className="btn btn-primary">
            Submit
          </button>
        )}
      </form>
    </div>
  );
};

export default AddFile;
